/**
 * Shared dedupe key for pixel (browser) + CAPI (server) event pairs.
 *
 * TikTok and Meta only collapse a browser event and a server event into one
 * conversion when the event name AND the event id match, so the same id has to
 * be handed to `ttq.track(..., { event_id })` and to the `/orders/events/*`
 * request body. Format mirrors the server's fallback ids (`atc-…`, `ic-…`).
 */
export const createEventId = (prefix) =>
  `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
